export default "__VITE_ASSET__9yH$xrcS__"